export default __webpack_public_path__ + "static/media/cooper-4.05a90c36.jpg";